import { isSameDay } from 'date-fns';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import type { TimeInfo } from '../DateTimeInfo';

export const useFormatDate = () => {
  const { t } = useTranslation();

  return useCallback(
    ({ timeInfo }: { timeInfo: TimeInfo }) => {
      if ('dateTime' in timeInfo) {
        return t('dateFormats.shortMonthDayYear', {
          date: timeInfo.dateTime,
        });
      }

      if ('date' in timeInfo) {
        return t('dateFormats.shortMonthDayYear', {
          date: timeInfo.date,
        });
      }

      if (!isSameDay(timeInfo.dateFrom, timeInfo.dateTo)) {
        return t('dateFormats.dateTime', {
          date: {
            end: timeInfo.dateTo,
            start: timeInfo.dateFrom,
          },
        });
      }

      return t('dateFormats.shortMonthDayYear', {
        date: {
          end: timeInfo.dateTo,
          start: timeInfo.dateFrom,
        },
      });
    },
    [t],
  );
};
